import React, { lazy } from 'react';
import PrivateRoute from 'PrivateRoutes';
// import { ContactList } from './components';
const ContactList = lazy(() => import(/* webpackChunkName: "ContactList" */'./components'));
const routes = () => (
  <PrivateRoute exact path="/settings/Contact-List" component={ContactList} />
);

export default routes;



// WEBPACK FOOTER //
// src/modules/screens/settings/ContactList/routes.js